import { studyGroupsApi } from "@/lib/humhub-api/studyGroups";
import { usePaginatedStudyGroups } from "@/hooks/usePaginatedStudyGroups";
import {
  MY_STUDY_GROUPS_STALE_TIME_MS,
  studyGroupKeys,
} from "@/lib/queryKeys/studyGroupKeys";

export const useMyStudyGroups = (initialPage = 1, initialPerPage = 20) => {
  const {
    data,
    pagination,
    isLoading,
    error,
    handlePageChange,
    handlePerPageChange,
    refetch,
  } = usePaginatedStudyGroups({
    initialPage,
    initialPerPage,
    queryKey: studyGroupKeys.myStudyGroupsRoot[0],
    queryFn: (page, perPage) => studyGroupsApi.getMyStudyGroups(page, perPage),
    staleTime: MY_STUDY_GROUPS_STALE_TIME_MS,
  });

  return {
    data,
    pagination,
    isLoading,
    error,
    handlePageChange,
    handlePerPageChange,
    refetch,
  };
};
